import type {Dispatch, FC, SetStateAction} from 'react'
import {useState} from 'react'

interface Type {
  label: string
  value?: string
}

interface FilterField extends Type {
  types?: Type[]
  date?: {
    start: string
    end: string
  }
}

interface Props {
  filters: FilterField[]
  filterState: [any, Dispatch<SetStateAction<any>>]
}

const FilterMenu: FC<Props> = ({filters, filterState}) => {
  const [_filter, setFilter] = filterState // eslint-disable-line
  const [field, setField] = useState('')
  const [type, setType] = useState('')
  const [date, setDate] = useState({start: '', end: ''})
  return (
    <div className='menu menu-sub menu-sub-dropdown w-300px w-md-325px' data-kt-menu='true'>
      <div className='px-7 py-5'>
        <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
      </div>
      <div className='separator border-gray-200'></div>
      <div className='px-7 py-5' data-kt-user-table-filter='form'>
        <div className='mb-10'>
          <label className='form-label fs-6 fw-bold'>Field:</label>
          <select
            className='form-select form-select-solid fw-bolder'
            data-kt-select2='true'
            data-placeholder='Select option'
            data-allow-clear='true'
            data-kt-user-table-filter='role'
            data-hide-search='true'
            onChange={(e) => setField(e.target.value)}
            value={field}
          >
            <option value=''></option>
            {filters.map((filter) => (
              <option key={filter.value} value={filter.value}>
                {filter.label}
              </option>
            ))}
          </select>
        </div>
        {field &&
          (filters.find((f) => f.value === field)?.date ? (
            <div className='mb-10 d-flex justify-content-between'>
              <div className='col'>
                <label className='form-label fs-6 fw-bold'>Start:</label>
                <input
                  type='date'
                  className='form-control'
                  onChange={(e) => setDate((prev) => ({...prev, start: e.target.value}))}
                  value={date.start}
                />
              </div>
              <div className='col'>
                <label className='form-label fs-6 fw-bold'>End:</label>
                <input
                  type='date'
                  className='form-control'
                  onChange={(e) => setDate((prev) => ({...prev, end: e.target.value}))}
                  value={date.end}
                />
              </div>
            </div>
          ) : (
            <div className='mb-10'>
              <label className='form-label fs-6 fw-bold'>Type:</label>
              <select
                className='form-select form-select-solid fw-bolder'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                data-kt-user-table-filter='two-step'
                data-hide-search='true'
                onChange={(e) => setType(e.target.value)}
                value={type}
              >
                <option value=''></option>
                {filters
                  .find((f) => f.value === field)
                  ?.types?.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
              </select>
            </div>
          ))}
        <div className='d-flex justify-content-end'>
          <button
            type='button'
            className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
            data-kt-menu-dismiss='true'
            data-kt-user-table-filter='reset'
            onClick={() => {
              setField('')
              setType('')
              setDate({start: '', end: ''})
              setFilter({field: null, type: null})
            }}
          >
            Reset
          </button>
          <button
            type='button'
            className='btn btn-primary fw-bold px-6'
            data-kt-menu-dismiss='true'
            data-kt-user-table-filter='filter'
            onClick={() => {
              const dateFilter = field && filters.find((f) => f.value === field)?.date
              if (dateFilter) {
                const params = `&${dateFilter.start}${date.start}&${dateFilter.end}${date.end}`
                setFilter({field, params})
              } else {
                setFilter({field, type})
              }
            }}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  )
}

export default FilterMenu
